export default __webpack_public_path__ + "static/media/information.c2447219.svg";